import React from 'react'

import { TableHeadingType, ContentItemType } from '../../../common/types'
import PromoPreview, { PromoPreviewProps } from '../PromoPreview/PromoPreview'
import StatusPill from '../StatusPill/StatusPill'
interface MessagingTableProps {
  tableHeading: Array<TableHeadingType>
  contentList: Array<ContentItemType>
}

const MessagingTable: React.FC<MessagingTableProps> = ({
  contentList,
  tableHeading,
}) => {
  return (
    <div className="mt-3 overflow-hidden rounded-lg border border-solid border-gray-200 shadow-md">
      <table className="w-full table-fixed">
        <thead className="bg-gray-50">
          <tr>
            {tableHeading.map((heading, index) => (
              <th
                key={`header-${index}`}
                className={`bg-gray-100 px-4 py-4 text-xs font-medium text-gray-500 ${
                  heading.field === 'campaignName' ||
                  heading.field === 'callToAction'
                    ? 'w-[190px]'
                    : ''
                } ${heading.field === 'promo' ? 'w-[435px]' : ''} ${
                  heading.field === 'campaignName' ||
                  heading.field === 'callToAction' ||
                  heading.field === 'promo' ||
                  heading.field === 'title'
                    ? 'text-left'
                    : 'text-center'
                }`}
              >
                {heading.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {contentList.map((item, rowIndex) => (
            <tr key={`row-${rowIndex}`} className="hover:bg-blue-50">
              {tableHeading.map((heading) => {
                let cellValue = item[heading.field] as React.ReactNode
                const cellClassName = `border-t border-gray-200 px-4 py-2 text-sm ${
                  heading.field === 'campaignName' ||
                  heading.field === 'callToAction' ||
                  heading.field === 'promo' ||
                  heading.field === 'title'
                    ? 'text-left'
                    : 'text-center'
                } ${
                  heading.field === 'campaignName'
                    ? 'text-gray-900'
                    : 'text-gray-600'
                }`

                if (heading.field === 'promo') {
                  const promoItem = item as unknown as {
                    promo: PromoPreviewProps
                  }
                  cellValue = (
                    <PromoPreview
                      headerText={promoItem.promo.headerText}
                      paragraphText={promoItem.promo.paragraphText}
                      buttonText={promoItem.promo.buttonText}
                      onClickPromo={promoItem.promo.onClickPromo}
                      backgroundImageUrl={promoItem.promo.backgroundImageUrl}
                      buttonClass={promoItem.promo.buttonClass}
                    />
                  )
                } else if (heading.field === 'status') {
                  cellValue = item.statusTitle && (
                    <StatusPill
                      title={item.statusTitle}
                      type={item.statusType}
                    />
                  )
                } else if (heading.field === 'audience') {
                  const audiences = item.audience as string[]
                  const lowerCaseAudiences = audiences.map((audience: string) =>
                    audience.toLowerCase()
                  )

                  cellValue = (
                    <>
                      {lowerCaseAudiences.map(
                        (audience: string, index: number) => (
                          <div key={`audience-${index}`} className="my-2">
                            <StatusPill
                              title={audiences[index]} // Use the original value.
                              type={
                                audience === 'prospect'
                                  ? 'warning'
                                  : audience === 'member'
                                    ? 'indigo'
                                    : 'info'
                              }
                            />
                          </div>
                        )
                      )}
                    </>
                  )
                }

                return (
                  <td
                    key={`cell-${heading.id}-${rowIndex}`}
                    className={cellClassName}
                  >
                    {cellValue}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default MessagingTable
